export function getOffsetFromTageswechsel(
  timeString: string | undefined,
): number {
  if (!timeString) {
    return 0;
  }
  const [hours] = timeString.split(':');
  return parseInt(hours, 10);
}
